export default __webpack_public_path__ + "media/images/evangelion/header-evangelion-colour-dbe8ae7951c90eeccdea37632c8b4023.jpg";